export const isLocalFile = (url: string) => url.startsWith('data:image');
